module.exports = __webpack_public_path__ + "img/202601_05.7ea8e665.png";